<template>
  <v-card elevation="0" outlined class="d-flex flex-column h-100" min-height="350">
    <v-card-title class="pb-0">
      <v-icon color="secondary" large class="mr-2">art_track</v-icon>
      <div class="d-flex flex-column">
        <span class="primary--text monospace-font body-1 font-weight-medium">{{ $t("app.videoPlaylists") }}</span>
        <span class="subheader-font body-2">{{ $t("videoPlaylists.subtitle") }}</span>
      </div>
    </v-card-title>
    <v-card-text class="d-flex flex-column pb-1 flex-grow-1">
      <v-data-table dense disable-items-per-page 
        :headers="headers" 
        :items="playlists"
        :footer-props="{ itemsPerPageOptions: $vuetify.breakpoint.smAndDown ? [1] : [5]}"
        class="pa-0"
        :loading="loading"
      >
        <!--Name-->
        <template v-slot:item.name="{ item }">
          <router-link :to="`/video-highlights/playlist/${item.id}`" target="_blank">
            <span class="font-weight-medium primary--text body-1">{{ item.name }}</span>
          </router-link>
        </template>
        <!--Created-->
        <template v-slot:item.createdTime="{ item }">
          <span class="body-1">{{ item.createdAt }}</span>
        </template>
        <!--Used-->
        <template v-slot:item.usedTime="{ item }">
          <span class="body-1">{{ item.usedAt }}</span>
        </template>
      </v-data-table>
      <v-divider class="mt-1"></v-divider>
    </v-card-text>
    <v-card-actions class="justify-end flex-shrink-0">
      <v-btn color="secondary" class="elevation-0 monospace-font white--text px-5" rounded small :to="`/video-playlists`">{{$t('videoPlaylists.seeAllPlaylists')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment';
import UserService from '../../../services/user.service';

export default {
  name: "CapturePlaylistsWidget",
  data() {
    return {
      loading: false,
      playlists: [],
      headers: [
        {
          text: this.$t("playerDetail.name"),
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("table.usersOfClient.created"),
          value: "createdTime",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("general.lastVisit"),
          value: "usedTime",
          align: "center",
          sortable: false,
        },
      ]
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  async created() {
    await this.loadViewData();
  },
  methods: {
    async loadViewData(){
      this.loading = true;
      const playlistsData = await UserService.getAllPlaylists();
      this.playlists = _.chain(playlistsData.data).map(p => {
        p.filtersParsed = JSON.parse(p.filters);
        p.createdTime = moment(p.createdAt,'DD/MM/YYYY HH:mm').unix();
        p.usedTime = moment(p.usedAt,'DD/MM/YYYY HH:mm').unix();
        return p;
      }).orderBy(['usedTime','createdTime','name'],['desc','desc','asc']).value();
      this.loading = false;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/views/dashboard/widgets/CapturePlaylistsWidget.vue